import { action } from 'satcheljs';
import { VendorList } from 'consent-string';

export const toggleAllowAccess = action('adsPrefsOption_toggleAllowAcess');
export const toggleAllowPersonalization = action('adsPrefsOption_toggleAllowPersonalization');
export const toggleAllowAdSelection = action('adsPrefsOption_toggleAllowAdSelection');
export const toggleAllowContentSelection = action('adsPrefsOption_toggleAllowContentSelection');
export const toggleAllowMeasurement = action('adsPrefsOption_toggleAllowMeasurement');
export const setOptions = action(
    'adsPerfsOption_setOptions',
    (options: {
        consentString: string;
        allowAccess: boolean;
        allowAdSelection: boolean;
        allowContentSelection: boolean;
        allowPersonalization: boolean;
        allowMeasurement: boolean;
    }) => ({ options })
);
export const switchView = action(
    'adsPerfsOption_switchView',
    (switchToGdprPartnerListView: boolean) => ({
        switchToGdprPartnerListView: switchToGdprPartnerListView,
    })
);
export const retrieveVendorList = action('adsPrefsOption_retrieveVendorList');
export const setVendorList = action('adsPrefsOption_setVendorList', (vendorList: VendorList) => {
    return {
        vendorList: vendorList,
    };
});

export const setFormDirty = action('adsPerfsOption_setFormDirty', (setFormDirty: boolean) => ({
    setFormDirty: setFormDirty,
}));
